import { apiClient } from '@/lib/apiClient';
import type {
  FiltrosProjetos, ProjetoResumo, ProjetoDetalhe, CriarProjetoRequest, AtualizarProjetoRequest,
  ProjetoFase, SalvarFaseRequest,
  ProjetoTarefa, SalvarTarefaRequest,
  ProjetoDependencia, AdicionarDependenciaRequest, Gantt,
} from '../types';

const BASE = '/api/projetos';

export const projetosService = {
  // Projetos
  listar: (filtros: FiltrosProjetos = {}) =>
    apiClient.get<ProjetoResumo[]>(BASE, { params: filtros }).then(r => r.data),
  obter: (id: number) =>
    apiClient.get<ProjetoDetalhe>(`${BASE}/${id}`).then(r => r.data),
  criar: (req: CriarProjetoRequest) =>
    apiClient.post<ProjetoDetalhe>(BASE, req).then(r => r.data),
  atualizar: (id: number, req: AtualizarProjetoRequest) =>
    apiClient.put<ProjetoDetalhe>(`${BASE}/${id}`, req).then(r => r.data),
  excluir: (id: number) =>
    apiClient.delete(`${BASE}/${id}`).then(r => r.data),

  // Fases
  listarFases: (projetoId: number) =>
    apiClient.get<ProjetoFase[]>(`${BASE}/${projetoId}/fases`).then(r => r.data),
  criarFase: (projetoId: number, req: SalvarFaseRequest) =>
    apiClient.post<ProjetoFase>(`${BASE}/${projetoId}/fases`, req).then(r => r.data),
  atualizarFase: (projetoId: number, faseId: number, req: SalvarFaseRequest) =>
    apiClient.put<ProjetoFase>(`${BASE}/${projetoId}/fases/${faseId}`, req).then(r => r.data),
  excluirFase: (projetoId: number, faseId: number) =>
    apiClient.delete(`${BASE}/${projetoId}/fases/${faseId}`).then(r => r.data),

  // Tarefas
  listarTarefas: (projetoId: number) =>
    apiClient.get<ProjetoTarefa[]>(`${BASE}/${projetoId}/tarefas`).then(r => r.data),
  criarTarefa: (projetoId: number, req: SalvarTarefaRequest) =>
    apiClient.post<ProjetoTarefa>(`${BASE}/${projetoId}/tarefas`, req).then(r => r.data),
  atualizarTarefa: (projetoId: number, tarefaId: number, req: SalvarTarefaRequest) =>
    apiClient.put<ProjetoTarefa>(`${BASE}/${projetoId}/tarefas/${tarefaId}`, req).then(r => r.data),
  excluirTarefa: (projetoId: number, tarefaId: number) =>
    apiClient.delete(`${BASE}/${projetoId}/tarefas/${tarefaId}`).then(r => r.data),

  // Dependências
  listarDependencias: (projetoId: number) =>
    apiClient.get<ProjetoDependencia[]>(`${BASE}/${projetoId}/dependencias`).then(r => r.data),
  adicionarDependencia: (projetoId: number, req: AdicionarDependenciaRequest) =>
    apiClient.post<ProjetoDependencia>(`${BASE}/${projetoId}/dependencias`, req).then(r => r.data),
  removerDependencia: (projetoId: number, depId: number) =>
    apiClient.delete(`${BASE}/${projetoId}/dependencias/${depId}`).then(r => r.data),

  // Gantt
  gantt: (projetoId: number) =>
    apiClient.get<Gantt>(`${BASE}/${projetoId}/gantt`).then(r => r.data),
};
